








































































































































































































































































































































































































































































import Vue from "vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import store, { PreAccountingStore } from "../services/PreAccountingStore";
import { PreAccDimCode, PreAccEditItem, PreAccItemTemplate } from "../models/PreAccEditing";
import LookupComboBox from "@/components/LookupComboBox.vue";
import IconButton from '@/components/IconButton.vue';
import CheckBox from "@/components/CheckBox.vue";
import DateInput from "@/components/DateInput.vue";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";



interface Data {
  store: PreAccountingStore;
  totalTemp: number;
  templateMenu: boolean;
  template: PreAccItemTemplate | null;
}

interface Methods {
  onRowClick(item: any): void;
  toggleMarked(item: PreAccEditItem): void;
  openTemplate(): void;
  applyTemplate(): void;
  onTemplateAccNoChanged(newValue: any): void;
  onTemplateDimCodeChanged(field: string, newValue: any): void;
  tplFlag(field: string): boolean;
  toggleTplFlag(field: string): void;
  tplText(field: string): string;
  onValueChanged(item: PreAccEditItem): void;
  onTotalChanged(item: PreAccEditItem): void;
  dimCodes(type: number): PreAccDimCode[];
  bookTypeName(id: number): string;
  detailedTypeName(id: number): string;
  onAccNoValueChanged(item: PreAccEditItem, newValue: any): void;
  onDimCodeValueChanged(item: PreAccEditItem, field: string, newValue: any): void;
  sizeDetailBoxes(): void;
  toggleExpandRow(item: PreAccEditItem): void;
  deleteItem(item: PreAccEditItem): void;
  setSelectedElements(item: PreAccEditItem): void;
  columnReorder(options: any): void;
}

interface Computed {
  items: PreAccEditItem[];
  itemsTotalValue: string;
  itemsTotalNegativeValue: string;
  itemsTotalPositiveValue: string;
  totalDisplay: string;
  sideAccSign: string;
  markedItems: PreAccEditItem[];
  isMix: boolean;
  itemsLocked: boolean;
  newItemTooltip: string;
  copyTooltip: string;
  templateDisabled: boolean;
  templateTooltip: string;
  templateDimRows: any[];
}

interface Props {
  positiveNegative: string;
  columns: any[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  mounted() {
    // this.$refs.copyTransWDim kivéve a dimenziós másoló gombbal együtt
    this.$emit('register-focus', [this.$refs.copyTrans, this.$refs.newTrans])

    // A nyitott detail-dobozok kövessék az oldal/tábla átméretezését ÉS a vízszintes
    // görgetést (DLMP471 TransactionItemEdit mintája).
    const gridEl = (this.$refs.itemsGrid as any)?.$el as HTMLElement | undefined;
    if (gridEl && typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(() => this.sizeDetailBoxes());
      observer.observe(gridEl);
      (this as any)._detailResizeObserver = observer;
    } else {
      window.addEventListener("resize", this.sizeDetailBoxes);
    }
    const content = gridEl ? gridEl.querySelector(".k-grid-content") : null;
    if (content) {
      content.addEventListener("scroll", this.sizeDetailBoxes, { passive: true });
      (this as any)._detailScrollEl = content;
    }
  },

  beforeDestroy() {
    const observer = (this as any)._detailResizeObserver as ResizeObserver | undefined;
    if (observer) observer.disconnect();
    window.removeEventListener("resize", this.sizeDetailBoxes);
    const scrollEl = (this as any)._detailScrollEl as HTMLElement | undefined;
    if (scrollEl) scrollEl.removeEventListener("scroll", this.sizeDetailBoxes);
  },

  components: {
    MoneyDisplay,
    LookupComboBox,
    IconButton,
    CheckBox,
    DateInput,
  },
  props: {
    // 'negative' = Tartozik ('+', bal oldal), 'positive' = Követel ('-', jobb oldal),
    // 'both' = egy táblás nézet (minden tétel)
    positiveNegative: { type: String },
    columns: {type: Array, required: true},
  },
  data() {
    return {
      store,
      totalTemp: 0,
      templateMenu: false,
      template: null as PreAccItemTemplate | null,
    };
  },
  computed: {
    sideAccSign(){
      return this.$props.positiveNegative == "positive" ? "-" : "+";
    },
    items(){
      //A modellhez computedben hozzáfűzöm .map-el feltételesen a selected boolean propertyt, így ki tudom jelölni a sort.
      return this.store.items.filter((x: PreAccEditItem) =>
        this.$props.positiveNegative == "both" ? true : x.accSign == this.sideAccSign
      ).map(item =>
        {
          item.selected = item === this.store.selectedItem;
          item.inEdit = item === this.store.selectedItem;
          return item;
        });
    },
    itemsTotalValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.reduce((currentSumNumber: number, arrayItem: PreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalNegativeValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "+").reduce((currentSumNumber: number, arrayItem: PreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    itemsTotalPositiveValue(){
      return new Intl.NumberFormat('hu-HU').format(this.items.filter(x => x.accSign == "-").reduce((currentSumNumber: number, arrayItem: PreAccEditItem) => currentSumNumber + Number(arrayItem.total), 0));
    },
    // K2D: a sablon a 'sel' oszlopban kijelölt sorokra érvényesül — ebben a gridben
    markedItems(){
      return this.items.filter((x: PreAccEditItem) => x.marked);
    },

    // MIX gyűjtőbizonylat: a K2D w_response_mix tétel-gridjén NINCS sem sablon-blokk,
    // sem sormásolás, sem 'sel' kijelölő oszlop (azok a w_popup_fokonyv sajátjai),
    // csak új tétel felvitele — ezért itt is csak a hozzáadás marad
    isMix(){
      return this.store.head.isMix === true || this.store.head.code === "MIX";
    },

    // K2D w_response_mix open: ii_oper 6/7-nél a pb_insert_*/pb_delete_* gombok
    // tiltottak, és a dw_master::retrieveend egyik ága sem oldja fel őket (a
    // visszakapcsoló sorok kikommentezve) — meglévő MIX bizonylaton a tételek
    // csak módosíthatók. Új MIX felvitelnél (ii_oper = 2) a gombok élnek.
    itemsLocked(){
      return this.store.isReadOnlyView || (this.isMix && !this.store.isCreateMode);
    },

    newItemTooltip(){
      if (this.store.isReadOnlyView) return t("PreAccounting_MegtekintesiModbanNemModosithato");
      if (this.isMix && !this.store.isCreateMode) return t("PreAccounting_MeglevoMIXBizonylatonNincsTetelFelvetel");
      return t("Transactions_UjTetelLetrehozas");
    },

    copyTooltip(){
      if (this.isMix) return t("PreAccounting_MIXBizonylatonNincsTetelMasolas");
      if (this.store.isReadOnlyView) return t("PreAccounting_MegtekintesiModbanNemModosithato");
      return t("Transactions_TetelMasolasa");
    },

    // K2D-ben ez messagebox (nincs kijelölt tétel); a webes megfelelője, hogy
    // a gomb addig tiltott — így a hiba be sem következhet
    templateDisabled(){
      return this.store.isReadOnlyView || this.isMix || this.markedItems.length === 0;
    },

    templateTooltip(){
      if (this.isMix) return t("PreAccounting_MIXBizonylatonNincsSablonosModositas");
      if (this.store.isReadOnlyView) return t("PreAccounting_MegtekintesiModbanNemModosithato");
      if (this.markedItems.length === 0)
        return t("PreAccounting_NincsKijeloltTetelAmelyreErvenyesiteniLehetne");
      return t("PreAccounting_SablonosModositasKijeloltTetel", [this.markedItems.length]);
    },

    // K2D d_f_template constructor: külső főkönyvnél a halott dimenziótípus sora rejtett
    templateDimRows(){
      const flags = this.store.flags;
      const rows = [
        { title: t("Dim1"), field: "dimCode1", applyField: "applyDimCode1", type: 2 },
        { title: t("GeneralLedger_Dim2"), field: "dimCode2", applyField: "applyDimCode2", type: 3 },
        { title: t("GeneralLedger_Dim3"), field: "dimCode3", applyField: "applyDimCode3", type: 4 },
      ];
      return rows.filter((r) => !(flags.extBook && flags.dimTypeLive[r.type] === false));
    },

    totalDisplay: {
      get() {
        return this.totalTemp
          ? new Intl.NumberFormat('hu-HU',{ maximumFractionDigits: 2}).format(this.totalTemp)
          : '';
      },
      set(val) {
        const normalized = val
                .replace(/\s/g, '')      // szóközök eltávolítása
                .replace(',', '.');
        const numeric = parseFloat(normalized);

        this.totalTemp = Number(numeric);
      }
    },

  },
  methods: {
    onRowClick(event){
      this.store.selectedItem = event.dataItem;
    },
    setSelectedElements(item){
      if(item.accSign == "-"){
        this.store.positiveSelectedItem = item;
      }
      else{
        this.store.negativeSelectedItem = item;
      }
    },
    onValueChanged(item){
      // A „módosított-e" számontartás a store-ban közös, mert a sablonos módosítás is ezt használja
      this.store.syncModified(item);
    },

    // K2D dw_tartozik::clicked (sel oszlop): a tétel kijelölése a sablonos módosításhoz.
    // Az aktuális (fókuszált) sor kiemelését NEM érinti — a kettő független.
    toggleMarked(item){
      if (this.store.isReadOnlyView) return;
      item.marked = !item.marked;
    },

    // K2D ue_template sablon-ága: első megnyitáskor a KIJELÖLT sor értékeiből seedel,
    // később az oldalra eltett sablont hozza vissza (inv_tart_template / inv_kov_template).
    openTemplate(){
      const side = this.$props.positiveNegative;
      const stored = this.store.itemTemplates[side];

      if (stored) {
        this.template = { ...stored };
      } else {
        const source =
          side === "positive" ? this.store.positiveSelectedItem
          : side === "negative" ? this.store.negativeSelectedItem
          : this.store.selectedItem;

        if (!source || !this.store.items.includes(source)) {
          // A K2D itt némán visszatér; jelezzük, mert a semmittevés hibának látszik
          eventBus.$emit("warn", t("PreAccounting_ElobbAlljonArraATetelreAmelynek"));
          return;
        }

        const flags = this.store.flags;
        this.template = {
          accCode: source.accCode,
          accCodeName: source.accCodeName,
          total: Number(source.total) || 0,
          currency: source.currency,
          accDate: String(source.accDate).split("T")[0],
          note: source.note,
          dimType: source.dimType,
          dimCode1: source.dimCode1,
          dimCode2: source.dimCode2,
          dimCode3: source.dimCode3,
          detailedType: source.detailedType,

          applyAccCode: true,
          applyTotal: true,
          applyAccDate: true,
          applyNote: true,
          applyDimType: true,
          // K2D: a dimenziókódok csak külső főkönyvnél és csak az élő típusokra
          // indulnak bepipálva (gb_ext_book + gb_dimcode)
          applyDimCode1: flags.extBook && flags.dimTypeLive[2] !== false,
          applyDimCode2: flags.extBook && flags.dimTypeLive[3] !== false,
          applyDimCode3: flags.extBook && flags.dimTypeLive[4] !== false,
          applyDetailedType: true,
        };
      }

      this.templateMenu = true;
    },

    // K2D: végigmegy a kijelölt sorokon, és CSAK a bepipált mezőket írja át
    applyTemplate(){
      const tpl = this.template;
      if (!tpl) return;

      const targets = this.markedItems;
      targets.forEach((item: PreAccEditItem) => {
        if (tpl.applyAccCode) {
          item.accCode = tpl.accCode;
          // K2D: az acc_code-dal együtt a fk. szám neve (acc_nat) is frissül
          item.accCodeName =
            this.store.accNos.find((x: any) => String(x.accno) === String(tpl.accCode))?.name ?? tpl.accCodeName;
        }
        if (tpl.applyTotal) item.total = Number(tpl.total) || 0;
        // K2D-sajátosság 1:1 — a pénznemnek nincs jelölője a sablon-űrlapon (a currency_b
        // oszlop létezik, de nincs kirakva a d_f_template-re), ezért MINDIG érvényesül.
        // A panelen látszik és szerkeszthető, "mindig érvényesül" felirattal.
        item.currency = tpl.currency;
        if (tpl.applyAccDate) item.accDate = tpl.accDate;
        if (tpl.applyNote) item.note = tpl.note;
        if (tpl.applyDimType) item.dimType = tpl.dimType;
        if (tpl.applyDimCode1) item.dimCode1 = tpl.dimCode1;
        if (tpl.applyDimCode2) item.dimCode2 = tpl.dimCode2;
        if (tpl.applyDimCode3) item.dimCode3 = tpl.dimCode3;
        if (tpl.applyDetailedType) item.detailedType = tpl.detailedType;
        this.store.syncModified(item);
      });

      // A sablon oldalanként megjegyződik (K2D inv_tart_template / inv_kov_template)
      this.store.itemTemplates[this.$props.positiveNegative] = { ...tpl };
      this.templateMenu = false;
      eventBus.$emit("success", t("PreAccounting_TetelModositvaASablonSzerint", [targets.length]));
    },

    onTemplateAccNoChanged(newValue){
      if (!this.template) return;
      this.template.accCode = newValue.accNo;
      this.template.accCodeName = newValue.name;
    },

    onTemplateDimCodeChanged(field, newValue){
      if (!this.template) return;
      (this.template as any)[field] = newValue.dimcode;
    },

    tplFlag(field){
      return this.template ? Boolean((this.template as any)[field]) : false;
    },

    toggleTplFlag(field){
      if (!this.template) return;
      (this.template as any)[field] = !(this.template as any)[field];
    },

    tplText(field){
      return this.template ? String((this.template as any)[field] ?? "") : "";
    },
    // K2D itemchanged 'total' ága: üres, nem szám vagy nulla összeg → üzenet és a
    // szerkesztés előtti érték áll vissza (a K2D Return 1-gyel utasítja el a beírást)
    onTotalChanged(item){
      if (!this.totalTemp || isNaN(this.totalTemp)) {
        eventBus.$emit("warn", t("PreAccounting_UresVagyHibasanKitoltottMezo"));
        this.totalTemp = item.total;
        return;
      }
      item.total = this.totalTemp;
      this.onValueChanged(item);
    },
    dimCodes(type){
      return this.store.dimCodes.filter((i: PreAccDimCode) => i.type == type)
    },
    bookTypeName(id){
      return this.store.bookTypes.find(x => x.id == id)?.name ?? String(id);
    },
    detailedTypeName(id){
      return this.store.detailedTypes.find(x => x.id == id)?.name ?? String(id);
    },
    onAccNoValueChanged(item,newValue){
      item.accCode = newValue.accNo;
      item.accCodeName = newValue.name;
    },
    onDimCodeValueChanged(item,field,newValue){
      (item as any)[field] = newValue.dimcode;
    },
    // A kinyíló törlés-megerősítő pozicionálása. A CSS sticky a Kendo tábla-DOM-ban
    // megbízhatatlan (cellán és belső dobozon is), ezért KÉZI "sticky": a doboz a
    // tábla LÁTHATÓ szélességét veszi fel, és a grid vízszintes scroll-pozíciójával
    // toljuk el (translateX), így görgetésnél és átméretezésnél is a látótérben marad.
    // Újrahívja: sor-nyitás, a grid scroll eseménye és a ResizeObserver.
    // (DLMP471 TransactionItemEdit-ből átvéve.)
    sizeDetailBoxes(){
      const grid = this.$refs.itemsGrid as any;
      if (!grid || !grid.$el) return;
      const gridEl = grid.$el as HTMLElement;
      const content = gridEl.querySelector('.k-grid-content') as HTMLElement | null;
      const visibleWidth = (content || gridEl).clientWidth;
      const scrollLeft = content ? content.scrollLeft : 0;
      gridEl.querySelectorAll('.k-detail-cell').forEach((el) => {
        const cell = el as HTMLTableCellElement;
        // korábbi (cellára tett) sticky maradványainak törlése
        cell.style.position = "";
        cell.style.left = "";
        const box = cell.firstElementChild as HTMLElement | null;
        if (box && visibleWidth > 0) {
          // a doboz természetes kezdőpontja a hierarchia-cella után van — ennyivel kevesebbet tolunk
          const hierarchyOffset = (cell.previousElementSibling as HTMLElement | null)?.offsetWidth || 0;
          box.style.position = "";
          box.style.left = "";
          box.style.width = visibleWidth + "px";
          box.style.boxSizing = "border-box";
          box.style.transform = `translateX(${Math.max(0, scrollLeft - hierarchyOffset)}px)`;
        }
      });
    },

    toggleExpandRow(item){
      item.deleting = !item.deleting

      this.$nextTick(() =>{
        this.sizeDetailBoxes();
      });
    },
    deleteItem(item){
      this.$emit('deleteItem',item)
    },
    columnReorder(options){
      this.$emit('columnReorder',options.columns)
    },
  },
  watch:{
    'store.selectedItem'(item) {
      this.totalTemp = item.total;

      const sideMatch = this.$props.positiveNegative == "both" || item.accSign == this.sideAccSign;
      if(sideMatch && !this.store.isReadOnlyView){
        this.$nextTick(() => {
          // Üres listánál a selectedItem egy alapértelmezett tétel, ami NINCS a listában
          // (indexOf = -1), így a firstField_-1 ref nem létezik — ilyenkor nincs mit fókuszálni.
          const idx = store.items.indexOf(item);
          if (idx < 0) return;
          const field = this.$refs['firstField_' + idx] as any;
          field?.$el?.querySelector('input')?.focus();
        })
      }

      if(this.$props.positiveNegative == "both" || item.accSign == this.sideAccSign){
        this.setSelectedElements(item);
      }
    },
  }
});
